import React from 'react'
import { Box, Grid, Stack, Typography } from '@mui/material'

export type DataRow<T extends Record<any, any>> = { key: keyof T; label: string; renderer: React.ElementType }

export interface DataBlockProps<T extends Record<string, any>> {
  items: Array<DataRow<T>>
  data: T
}

export const DataBlock = <T extends Record<string, any>>({
  items,
  data,
  children,
}: React.PropsWithChildren<DataBlockProps<T>>): React.ReactElement => {
  return (
    <Box
      sx={{
        p: 4,
        width: '100%',
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'lines.grey',
      }}
    >
      <Stack direction="column" gap={3}>
        {items.map(({ key, label, renderer: Renderer }) => (
          <Grid container key={key as string} spacing={1}>
            <Grid item xs={6} lg={5}>
              <Typography variant="body1" color="text.secondary">
                {label}
              </Typography>
            </Grid>
            <Grid item xs={6} lg={7}>
              <Renderer {...data} value={data[key]} />
            </Grid>
          </Grid>
        ))}
        {children}
      </Stack>
    </Box>
  )
}
